<p-steps [model]="wizard.steps" [(activeIndex)]="wizard.currentStep">
  <p translate>add-learners-step.add-learner-info</p>
</p-steps>
<ng-container [ngSwitch]="wizard.currentStep">
  <ng-container *ngSwitchCase="AddLearnersStepsEnum.Add">
    <vnm-add-learners-step
      [learners]="wizard.learners"
      (learnersAdded)="onLearnersAdded($event)"
      (cancel)="sidebarToggle.close()"
      (nextStep)="nextStep()"
    ></vnm-add-learners-step>
  </ng-container>
  <ng-container *ngSwitchCase="AddLearnersStepsEnum.Confirm">
    <ng-container *ngIf="organizations$ | async as organizations">
      <vnm-tile-card
        *ngIf="organizations.length > 1"
        header="add-learners-wizard.share-w-organizations"
        subheader="add-learners-wizard.accessible-w-organizations"
      >
        <p-multiSelect
          [placeholder]="'add-learners-wizard.select-organizations' | translate"
          [options]="organizations | dropdownOptions: true"
          [(ngModel)]="wizard.organizationIds"
          appendTo="body"
        ></p-multiSelect>
      </vnm-tile-card>
    </ng-container>
    <vnm-confirm-learners-table
      [learners]="wizard.learners"
      (allLearnersRemoved)="prevStep()"
    ></vnm-confirm-learners-table>
    <p-footer>
      <button
        pButton
        type="button"
        icon="fa fa-fw fa-angle-left"
        [label]="'add-learners-wizard.input-import-learners' | translate"
        [disabled]="!wizard.learners.length"
        class="p-button-secondary"
        (click)="prevStep()"
      ></button>
      <button
        pButton
        type="button"
        icon="fa fa-fw fa-angle-right"
        iconPos="right"
        [label]="'add-learners-wizard.complete-import-learners' | translate"
        [disabled]="!wizard.learners.length"
        (click)="importLearners()"
      ></button>
    </p-footer>
  </ng-container>
  <ng-container *ngSwitchCase="AddLearnersStepsEnum.Import">
    <vnm-empty-message
      [icon]="wizard.imported.length ? 'user-check' : 'user-times'"
      [message]="
        'add-learners-wizard.learners-imported'
          | translate: { imported: wizard.imported.length, errors: wizard.errors.length }
      "
      [loading]="wizard.running"
      loadingMessage="add-learners-wizard.importing-learners"
      class="result-message"
      [ngClass]="{
        'has-imports': wizard.imported.length,
        'has-errors': wizard.errors.length
      }"
    ></vnm-empty-message>
    <!-- Custom errors cause the p-message is ugly -->
    <div class="import-error-list">
      <div @fade class="import-error" *ngFor="let error of wizard.errors">
        <div class="details-wrapper">
          <fa-icon icon="exclamation-triangle"></fa-icon>
          <div class="error-details">
            <strong>{{ error.message }}</strong>
            <span>{{ error.detail.invitee.firstName }} {{ error.detail.invitee.lastName }}</span>
            <vnm-user-contacts [user]="error.detail.invitee"></vnm-user-contacts>
          </div>
        </div>
      </div>
    </div>
    <p-footer>
      <button
        pButton
        type="button"
        icon="fa fa-fw fa-angle-left"
        [label]="'add-learners-wizard.edit-import-errors' | translate"
        *ngIf="wizard.errors.length"
        (click)="editErroredLearners()"
      ></button>
      <button
        pButton
        type="button"
        icon="fa fa-fw fa-times"
        class="p-button-secondary"
        [label]="'app.close' | translate"
        *ngIf="!wizard.errors.length"
        (click)="sidebarToggle.close()"
      ></button>
      <button
        pButton
        type="button"
        icon="fa fa-fw fa-angle-right"
        iconPos="right"
        [label]="'add-learners-wizard.assign-training-learners' | translate: { count: wizard.imported.length }"
        [disabled]="!wizard.imported.length"
        (click)="assignTraining()"
      ></button>
    </p-footer>
  </ng-container>
  <p-toast [baseZIndex]="5000"></p-toast>
</ng-container>
